export default "__VITE_ASSET__2abd3889__"